import React, { FC, memo } from 'react';
import loadable from '@loadable/component';
import { useModalsContext, useToggleModalsContext } from '../../contexts/ModalsContext';
import { CommunicationTermsProps } from './CommunicationTerms';

const CommunicationTerms = loadable(
  () => import(/* webpackChunkName: 'communicationTerms' */'./CommunicationTerms'),
);

export interface CommunicationTermsModalProps {
  modalProps: CommunicationTermsProps;
}

const globalAny: any = global; // TODO:  hack to add properties to Global object

const CommunicationTermsModal: FC<CommunicationTermsModalProps> = ({
  modalProps,
}: CommunicationTermsModalProps) => {
  const { modalsState } = useModalsContext();
  const toggleModal = useToggleModalsContext();
  const { isCommunicationTermsModalOpen: isShow } = modalsState;

  // TODO:  hack! remove after legacy pages migrate to React
  globalAny.toggleReactModal = toggleModal;
  // TODO: hack! remove after legacy pages migrate to React
  globalAny.modalsState = modalsState;

  if (!isShow) {
    return null;
  }

  return (
    <CommunicationTerms {...modalProps} />
  );
};

export default memo(CommunicationTermsModal);
